module.exports = __webpack_public_path__ + "img/ac1484727d6ce6e4a4e1775f4b83d4ac.jpg";